export {}; // this will make it module

declare global {
	// to access it as global type String
	interface String {
		sanitizeText(): string;
		sanitizeTextUrl(): string;
	}
}

String.prototype.sanitizeText = function () {
	if (this !== null && this !== undefined) {
		return this.replace(/<[^>]*>/g, ' ')
			.replace(/(http|https):\/\//g, ' ')
			.replace(/www[.]/g, ' ');
	}

	return this;
};

String.prototype.sanitizeTextUrl = function () {
	if (this !== null && this !== undefined) {
		return this.replace(/<[^>]*>/g, ' ');
	}

	return this;
};
